import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import a from "../util/net.js";
import t from "../common/base-provider.js";
import r from "../managers/braze-instance.js";
import ContentCards from "./content-cards.js";
import { dateFromUnixTimestamp as V } from "../util/date-utils.js";
import { isURIJavascriptOrData as tt } from "../util/url-utils.js";
import { newCardFromContentCardsJson as st, newCardFromSerializedValue as it } from "../Card/util/card-factory.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import u from "../managers/subscription-manager.js";
import h from "../util/request-header-utils.js";
import { randomInclusive as l } from "../util/math.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
var Z = /*#__PURE__*/function (_t) {
  _inherits(Z, _t);
  var _super = _createSuper(Z);
  function Z(t, s, i, e, h) {
    var _this;
    _classCallCheck(this, Z);
    _this = _super.call(this), _this.Cs = t, _this.j = s, _this.h = i, _this.vs = e, _this.B = h, _this.Cs = t, _this.j = s, _this.h = i, _this.vs = e, _this.B = h, _this.ws = new u(), r.q(_this.ws), _this.ys = 0, _this.Ss = 0, _this.cards = [], _this.Ts();
    var n = et.Us.Rs;
    new et(n, E).Ds(n.Fs.As, function (t) {
      _this.Ls(t);
    }), _this.Ns = null, _this.D = null, _this.Js = null, _this.Ms = null, _this.$s = 10;
    return _this;
  }
  _createClass(Z, [{
    key: "Bs",
    value: function Bs() {
      return this.Ns;
    }
  }, {
    key: "Es",
    value: function Es(t) {
      this.Ns = t;
    }
  }, {
    key: "jt",
    value: function jt() {
      return this.D;
    }
  }, {
    key: "yt",
    value: function yt(t) {
      this.D = t;
    }
  }, {
    key: "Ts",
    value: function Ts() {
      if (!this.j) return;
      var t = this.j.lt(s.ct.Ps) || [],
        i = [];
      for (var _s2 = 0; _s2 < t.length; _s2++) {
        var e = it(t[_s2]);
        null != e && i.push(e);
      }
      this.cards = this.Xs(this._s(i, !1)), this.ys = this.j.lt(s.ct.Gs) || this.ys, this.Ss = this.j.lt(s.ct.Hs) || this.Ss;
    }
  }, {
    key: "Is",
    value: function Is(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r;
      if (i) {
        r = [];
        var _iterator = _createForOfIteratorHelper(this.cards),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t2 = _step.value;
            _t2.test && r.push(_t2);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else r = this.cards.slice();
      for (var _s3 = 0; _s3 < t.length; _s3++) {
        var _e = t[_s3];
        var _h = null;
        for (var _t3 = 0; _t3 < this.cards.length; _t3++) if (_e.id === this.cards[_t3].id) {
          _h = this.cards[_t3];
          break;
        }
        if (i) {
          var _t4 = st(_e);
          null != _h && _h.viewed && _t4 && (_t4.viewed = !0), null != _t4 && r.push(_t4);
        } else if (null == _h) {
          var _t5 = st(_e);
          null != _t5 && r.push(_t5);
        } else {
          if (!_h.ri(_e)) for (var _t6 = 0; _t6 < r.length; _t6++) if (_e.id === r[_t6].id) {
            r.splice(_t6, 1);
            break;
          }
        }
      }
      this.cards = this.Xs(this._s(r, i)), this.Ks(), this.ys = e, this.Ss = h, this.j && (this.j.ft(s.ct.Gs, this.ys), this.j.ft(s.ct.Hs, this.Ss));
    }
  }, {
    key: "N",
    value: function N(t) {
      if (this.Os() && null != t && t.cards) {
        this.j && this.j.ft(s.ct.Qs, r.Vs());
        var i = t.full_sync;
        i || this.Ts(), this.Is(t.cards, i, t.last_full_sync_at, t.last_card_updated_at), this.ws.L(this.Ws(!0));
      }
    }
  }, {
    key: "Ys",
    value: function Ys(t) {
      this.Zs(), this.Js = t;
    }
  }, {
    key: "Ls",
    value: function Ls(t) {
      var s;
      if (!this.Os()) return;
      this.Ts();
      var i = this.cards.slice();
      var e = null;
      e = null === (s = this.Cs) || void 0 === s ? void 0 : s.getUserId();
      for (var _s4 = 0; _s4 < t.length; _s4++) if (e === t[_s4].userId || null == e && null == t[_s4].userId) {
        var _e2 = t[_s4].card;
        var _h2 = null;
        for (var _t7 = 0; _t7 < this.cards.length; _t7++) if (_e2.id === this.cards[_t7].id) {
          _h2 = this.cards[_t7];
          break;
        }
        if (null == _h2) {
          var _t8 = st(_e2);
          null != _t8 && i.push(_t8);
        } else {
          if (!_h2.ri(_e2)) for (var _t9 = 0; _t9 < i.length; _t9++) if (_e2.id === i[_t9].id) {
            i.splice(_t9, 1);
            break;
          }
        }
      }
      this.cards = this.Xs(this._s(i, !1)), this.Ks(), this.ws.L(this.Ws(!0));
    }
  }, {
    key: "_s",
    value: function _s(t, i) {
      var e = {},
        h = {},
        r = {};
      this.j && (e = this.j.lt(s.ct.Et) || {}, h = this.j.lt(s.ct.Pt) || {}, r = this.j.lt(s.ct.Lt) || {});
      var n = {},
        o = {},
        l = {};
      for (var _s5 = 0; _s5 < t.length; _s5++) {
        var _i = t[_s5].id;
        _i && (e[_i] && (t[_s5].clicked = !0, n[_i] = !0), h[_i] && (t[_s5].viewed = !0, o[_i] = !0), r[_i] && (t[_s5].dismissed = !0, l[_i] = !0));
      }
      return i && this.j && (this.j.ft(s.ct.Et, n), this.j.ft(s.ct.Pt, o), this.j.ft(s.ct.Lt, l)), t;
    }
  }, {
    key: "Xs",
    value: function Xs(t) {
      var i = [],
        e = new Date();
      var h = {};
      this.j && (h = this.j.lt(s.ct.Lt) || {});
      var r = !1;
      for (var _s6 = 0; _s6 < t.length; _s6++) {
        var n = t[_s6].url;
        if (!this.vs && n && tt(n)) {
          E.error("Card with url ".concat(n, " will not be displayed because Javascript URLs are disabled. Use the \"allowUserSuppliedJavascript\" option for braze.initialize to enable this card."));
          continue;
        }
        var o = t[_s6].expiresAt;
        var _l = !0;
        if (null != o && (_l = o >= e), _l = _l && !t[_s6].dismissed, _l) i.push(t[_s6]);else {
          var _i2 = t[_s6].id;
          _i2 && (h[_i2] = !0), r = !0;
        }
      }
      return r && this.j && this.j.ft(s.ct.Lt, h), i;
    }
  }, {
    key: "Ks",
    value: function Ks() {
      var t;
      var i = [];
      for (var _t10 = 0; _t10 < this.cards.length; _t10++) i.push(this.cards[_t10].dt());
      null === (t = this.j) || void 0 === t || t.ft(s.ct.Ps, i);
    }
  }, {
    key: "Zs",
    value: function Zs() {
      this.Js && (clearTimeout(this.Js), this.Js = null);
    }
  }, {
    key: "fi",
    value: function fi(t, i) {
      var _this2 = this;
      var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var n;
      var o = this.B,
        u = this.j;
      if (!o || !u) return void ("function" == typeof i && i());
      if (e && (h.Ci(u, h.H.bi), this.Zs()), !this.Os()) return void (null === (n = this.h) || void 0 === n || n.vi(function () {
        _this2.fi(t, i, !0);
      }));
      var c = o.$({}, !0);
      u.lt(s.ct.Qs) !== r.Vs() && this.wi(), c.last_full_sync_at = this.ys, c.last_card_updated_at = this.Ss;
      var f = o.A(c, h.H.bi, e);
      var d = !1;
      o.J(c, function () {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        if (_this2.j) {
          var _t11 = new Date().valueOf();
          h.K(_this2.j, h.H.bi, _t11);
        }
        -1 !== s && f.push(["X-Braze-Req-Tokens-Remaining", s.toString()]), a.O({
          url: "".concat(o.V(), "/content_cards/sync"),
          data: c,
          headers: f,
          W: function W(s) {
            if (!o.Y(c, s, f)) return d = !0, void ("function" == typeof i && i());
            o.Z(), _this2.N(s), d = !1, "function" == typeof t && t();
          },
          error: function error(t) {
            o._(t, "retrieving content cards"), d = !0, "function" == typeof i && i();
          },
          tt: function tt(s, e) {
            var r;
            if (d) {
              var _t12 = _this2.Ms;
              (null == _t12 || _t12 < 1e3 * _this2.$s) && (_t12 = 1e3 * _this2.$s), r = Math.min(3e5, l(1e3 * _this2.$s, 3 * _t12));
            }
            o.st(e, function () {
              _this2.fi(t, i, !1);
            }, h.H.bi, function (t) {
              return _this2.Ys(t);
            }, function () {
              return _this2.Zs();
            }, r);
          }
        });
      }, h.H.bi, i);
    }
  }, {
    key: "Ws",
    value: function Ws(t) {
      t || this.Ts();
      var i = this.Xs(this.cards);
      i.sort(function (t, s) {
        return t.pinned && !s.pinned ? -1 : s.pinned && !t.pinned ? 1 : t.updated && s.updated && t.updated > s.updated ? -1 : t.updated && s.updated && s.updated > t.updated ? 1 : 0;
      });
      var e = Math.max(this.Ss || 0, this.ys || 0);
      return 0 === e && (e = void 0), this.j && this.j.lt(s.ct.Hs) === this.Ss && void 0 === e && (e = this.Ss), new ContentCards(i, V(e));
    }
  }, {
    key: "St",
    value: function St(t) {
      return this.ws.wt(t);
    }
  }, {
    key: "wi",
    value: function wi() {
      this.ys = 0, this.Ss = 0, this.j && (this.j.Nt(s.ct.Gs), this.j.Nt(s.ct.Hs));
    }
  }, {
    key: "changeUser",
    value: function changeUser(t) {
      t || (this.cards = [], this.ws.L(new ContentCards(this.cards.slice(), null)), this.j && (this.j.Nt(s.ct.Ps), this.j.Nt(s.ct.Et), this.j.Nt(s.ct.Pt), this.j.Nt(s.ct.Lt))), this.Zs(), this.wi();
    }
  }, {
    key: "clearData",
    value: function clearData(t) {
      this.ys = 0, this.Ss = 0, this.cards = [], this.ws.L(new ContentCards(this.cards.slice(), null)), t && this.j && (this.j.Nt(s.ct.Ps), this.j.Nt(s.ct.Et), this.j.Nt(s.ct.Pt), this.j.Nt(s.ct.Lt), this.j.Nt(s.ct.Gs), this.j.Nt(s.ct.Hs)), this.Zs();
    }
  }, {
    key: "Os",
    value: function Os() {
      return !!this.h && (!!this.h.gi() || (0 !== this.h.Ft() && this.ji(), !1));
    }
  }, {
    key: "ji",
    value: function ji() {
      this.ws.L(new ContentCards([], new Date())), this.j && this.j.Nt(s.ct.Ps);
    }
  }]);
  return Z;
}(t);
export { Z as default };